import React from 'react'
import { Link } from 'react-router-dom';
import './Fantasy.css';

import Header from '../../sections/Header/Header';
import Footer from '../../sections/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import Dropdown from '../../components/Dropdown/Dropdown';

import { photos } from '../../../demo/demo';

const Fantasy = () => {

    return (
        <>
            <SEO title="Custom Fantasy Experiences Italy" description="Design your perfect fantasy experience in Rome or Milan. Luxury arrangements, elite talent, transportation, and bespoke scenarios crafted by our concierge team." />
            <Header whitebar={true} />
            <section className="model fantasy-page">
                <div className="model-view left">
                    <div className="model-view-desktop">
                        {photos.map((photo, i) => (
                            <div className="model-photo" key={i}>
                                <img src={photo} alt="" />
                            </div>
                        ))}
                        <Footer type={'side'} />
                    </div>
                </div>
                <div className="model-view right">
                    <div className="right-container scrollable">
                        <div className="model-name">Custom Fantasy</div>
                        <div className="model-city">Tailored Experience</div>

                        <Dropdown 
                            title={'Description'} 
                            defaultStatus={true} 
                            pad={true}
                            content={
                                <>
                                    <p>Design your perfect experience from start to finish. Our Custom Fantasy service 
                                    allows you to craft every detail — from the setting and ambiance to the talent and scenario. 
                                    We handle all logistics so you can focus entirely on living your dream.</p>
                                    <div className="fantasy-request">
                                        <Link to={'/fantasy/create'}>Request a Custom Fantasy</Link>
                                    </div>
                                </>
                            }    
                        />

                        <Dropdown 
                            title={'Transportation'}
                            content={
                                <>
                                    <p>Private airport transfers, luxury vehicle hire, and chauffeur services available 
                                    across all major Italian cities. We ensure seamless travel from the moment you arrive.</p>
                                    <ul className="fantasy-list">
                                        <li>Airport pickup & drop-off</li>
                                        <li>Luxury sedan or SUV</li>
                                        <li>Private chauffeur</li>
                                        <li>Multi-city transfers</li>
                                    </ul>
                                </>
                            }    
                        />

                        <Dropdown 
                            title={'Hotels'}
                            content={
                                <>
                                    <p>We partner with the finest hotels and private villas across Italy. 
                                    From boutique suites in Rome to penthouses in Milan, we arrange accommodations 
                                    that match the calibre of your experience.</p>
                                    <ul className="fantasy-list">
                                        <li>5-star hotel suites</li>
                                        <li>Private villas</li>
                                        <li>Penthouse apartments</li>
                                        <li>Discreet booking under our network</li>
                                    </ul>
                                </>
                            }    
                        />

                        <Dropdown 
                            title={'Arrangements'}
                            content={
                                <>
                                    <p>Every detail is handled by our concierge team. From dining reservations to 
                                    event access, wardrobe, and special requests — we make it happen.</p>
                                    <ul className="fantasy-list">
                                        <li>Restaurant reservations</li>
                                        <li>Private event access</li>
                                        <li>Wardrobe & styling</li>
                                        <li>Custom scenarios & themes</li>
                                        <li>Photography & videography</li>
                                    </ul>
                                </>
                            }    
                        />
                    </div>
                </div>
            </section>
        </>
    )
}

export default Fantasy
